import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { selectUserId } from "@common/reducers/UserSelectors";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import DiagnosticsView from "@common-views/diagnostics-view/diagnostics-view";
import { Stethoscope, X } from "lucide-react";
import { useState } from "react";

/**
 * Debug Diagnostics Button Component
 *
 * Self-contained component that includes:
 * - Debug mode check
 * - Button with tooltip
 * - Full-screen dialog with DiagnosticsView component
 *
 * Only renders when localStorage 'bt-debug' is 'true'
 */
export default function DebugDiagnosticsButton() {
    const [isOpen, setIsOpen] = useState(false);
    const userId = useAppSelector(selectUserId);

    // Only render if debug mode is enabled
    const isDebugEnabled = localStorage.getItem('bt-debug') === 'true';
    if (!isDebugEnabled) {
        return null;
    }

    return (
        <>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        onClick={() => setIsOpen(true)}
                        className="w-[38px] h-[38px] rounded-full flex items-center justify-center transition-colors relative text-orange-500 hover:bg-orange-100 hover:text-orange-600 border border-orange-300"
                    >
                        <Stethoscope size={20} />
                    </button>
                </TooltipTrigger>
                <TooltipContent side="bottom">
                    <p>Diagnostics (Debug)</p>
                </TooltipContent>
            </Tooltip>

            <Dialog open={isOpen} onOpenChange={setIsOpen}>
                <DialogContent
                    className="!fixed !inset-0 !max-w-none !max-h-none !w-screen !h-screen !p-0 !m-0 !border-none !rounded-none !translate-x-0 !translate-y-0 !top-0 !left-0 overflow-auto bg-white !z-[99999]"
                >
                    <DialogTitle className="sr-only">Diagnostics</DialogTitle>
                    <button
                        onClick={() => setIsOpen(false)}
                        className="absolute top-4 right-4 z-50 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center hover:bg-gray-100 transition-colors border border-gray-200"
                        aria-label="Close"
                    >
                        <X size={24} className="text-gray-600" />
                    </button>
                    <div className="w-full h-full overflow-auto">
                        <DiagnosticsView supportedUserId={userId} />
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}
